<template>
  <BaseNativeSelect
    :id="id"
    :name="name"
    :disabled="disabled"
    :value="inputValue || undefined"
    :error-message="errorMsg"
    :is-error-message-visible="isHasErrorMessage"
    @input="handleChange"
    @blur="handleBlur"
  >
    <slot />
  </BaseNativeSelect>
</template>

<script>
import { useField } from 'vee-validate';

import BaseNativeSelect from '@/components/ui/BaseNativeSelect';

export default {
	components: { BaseNativeSelect },
	props: {
		id: {
			type: String,
			required: false,
		},
		name: {
			type: String,
			required: true,
		},
		value: {
			type: String,
			required: false,
			default: '',
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	setup (props) {
		const {
			value: inputValue,
			errorMessage,
			handleBlur,
			handleChange,
		} = useField(props?.name || '', undefined, {
			initialValue: props?.value,
		});

		return {
			inputValue,
			handleBlur,
			handleChange,
			errorMessage,
		};
	},
	computed: {
		errorMsg () {
			return this?.errorMessage || '';
		},
		isHasErrorMessage () {
			return !!this.errorMsg;
		},
	},
};
</script>
